<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px">
        <el-row>
          <el-col :span="3">
              <el-image :src="baseURI+imgs.logo" style="height: 60px;"></el-image>
          </el-col>
 
          <el-col :span="8">
            <el-form-item   prop="skname">
              {{ formParameter.skname }} </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="层次" prop="level"> {{ formParameter.level }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="招生学年" prop="zsyear">
              <template v-if="isClone">
                  <el-input type="text" v-model="formParameter.cyear"
                autocomplete="off"></el-input>
              </template>
              <template v-else>
                  {{ formParameter.zsyear }}
              </template>
                </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-button size="mini" v-has-permission-code-and="'003000000005'" type="danger" @click="toEditSubs">{{ toEditTxt }}</el-button>
            <el-button size="mini" v-has-permission-code-and="'003000000005'" type="info" @click="toCloneSubs">{{ toCloneTxt }}</el-button>
            <el-button size="mini" v-has-permission-code-and="'003000000005'" type="success" v-show="isClone"
              @click="cloneData">完成克隆</el-button>
            <el-button size="mini" v-has-permission-code-and="'003000000005'" @click="toAddSubs" type="warning"
              v-show="!notEdit">加一行</el-button>
            <el-button size="mini" v-has-permission-code-and="'003000000005'" type="success" v-show="!notEdit"
              @click="submit">完成编辑</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table :data="subjects" style="width: 100%">

              <el-table-column label="logo"  width="50">
                <template slot-scope="scope">
                   <el-image   v-if="imgs.logoArrs" :src="baseURI+imgs.logoArrs[scope.$index*1]"  style="width: 40px;height: 40px;" ></el-image> 
                </template>
              </el-table-column>

              <el-table-column prop="nm" label="专业名称" width="180">
                <template slot-scope="scope">
                  <el-input size="mini" :readonly="notEdit" v-model="scope.row.nm" autocomplete="off">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="cd" label="专业代码" width="120">
                <template slot-scope="scope">
                  <el-input size="mini" :readonly="notEdit" v-model="scope.row.cd" autocomplete="off">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="tp" label="科目类型" width="120">
                <template slot-scope="scope">
                  <select-option-dictionary v-model="scope.row.tp" dkey="sub-type" :multiple="false"
                   :stringMode="true"></select-option-dictionary>
                </template>
              </el-table-column>
              <el-table-column prop="dj" label="学费1" width="100">
                <template slot-scope="scope">
                  <el-input size="mini" :readonly="notEdit" v-model="scope.row.dj" autocomplete="off">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="dj2" label="学费2" width="100">
                <template slot-scope="scope">
                  <el-input size="mini" :readonly="notEdit" v-model="scope.row.dj2" autocomplete="off">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="dj3" label="学费3" width="100">
                <template slot-scope="scope">
                  <el-input size="mini" :readonly="notEdit" v-model="scope.row.dj3" autocomplete="off">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="all" label="学费合计" width="100">
                <template slot-scope="scope">
                     {{ (scope.row.dj?scope.row.dj:0)*1+(scope.row.dj2?scope.row.dj2:0)*1+(scope.row.dj3?scope.row.dj3:0)*1 }}
                </template>
              </el-table-column>
              <el-table-column prop="ks" label="考试方式" width="180">
                <template slot-scope="scope">
                  <el-input size="mini" :readonly="notEdit" v-model="scope.row.ks" autocomplete="off">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80" v-if="!notEdit">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"  @click="delSub(scope.$index)">删除</el-button>
                </template> </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>


<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/xueli/xlschool.js";
import logoApi from "@/api/xueli/logo.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import constant from '@/util/constant.js';

export default {
  name: "subject",
  components: {
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      subjects: [],
      imgs:{logoArrs:[]},   //logo图片
      toEditTxt: "维护专业",
      notEdit: true,
      toCloneTxt: "克隆",
      isClone: false,
      baseURI: constant.serverUrl,
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled) {
      this.formParameter = parameter;
      this.subjects = this.formParameter.children

      //加载图片
      logoApi.listLogo({skid:this.formParameter.id},res=>{
        this.imgs = res.data
      })

      this.notEdit = true
      this.disabled = disabled;
      this.$refs.popup.open(title, "75%");
    },
    //关闭弹框  ：释放资源和重置初始值
    close() {
      this.disabled = false;
      this.isClone=false
      this.toEditTxt = "维护专业"
      this.toCloneTxt =  "克隆"
        this.$refs.popup.close();
    },
    toEditSubs() {
      if (this.toEditTxt == "取消维护") {
        this.toEditTxt = "维护专业"
      } else {
        this.toEditTxt = "取消维护"
      }
      this.notEdit = !this.notEdit
    },
    toCloneSubs() {
      if (this.toCloneTxt == "取消克隆") {
        this.toCloneTxt = "克隆"
      } else {
        this.toCloneTxt = "取消克隆"
      }
      this.isClone = !this.isClone;
    },
    toAddSubs() {

      if (this.subjects == undefined) {
        this.subjects = [];
      }
      //去添加
      this.subjects.push({ nm: "", cd: "", tp: "", dj: "",cnt: "",jc: "", ks: "" })
    },
    delSub(idx) {
      this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				 //删除
         this.subjects.splice(idx, 1)
			});
     
    },
    submit() {    //负责提交到后端

      this.$utils.confirm.warning('提示', '确定提交修改专业吗？', () => {
        //完成添加：格式化this.subjects为json，发到后端
        let prarm = { id: this.formParameter.id, subjects: JSON.stringify(this.subjects) }
        //发起请求
        api.updateSubs(prarm, res => {
          this.$utils.msg.success(res.msg);
          this.notEdit = true
          this.toEditTxt = "维护专业"
          // 刷新父页面
          this.$parent.list();
          
        })
      });
    },
    cloneData(){ 
      this.$utils.confirm.warning('提示', '确定提交克隆吗？', () => {
        let param = { id: this.formParameter.id, cyear: this.formParameter.cyear }
        //发起请求
        api.saveClone(param, res => {
          this.$utils.msg.success(res.msg);
          this.isClone = false;
          this.toCloneTxt = "维护专业";
          // 刷新父页面
          this.$parent.list();
          
        })
      });
    }
  }
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
